import { useContext } from 'react';
import ElapsedTimeContext from './context';
const useElapsedTime = () => {
    const elapsedTimeHelpers = useContext(ElapsedTimeContext);
    if (!elapsedTimeHelpers) {
        throw new Error('useElapsedTime cannot be used outside of ElapsedTimeProvider');
    }
    return elapsedTimeHelpers;
};
export default useElapsedTime;
//# sourceMappingURL=useElapsedTime.js.map